var styleDataHash = "07a9d01e";
const injectCss = () => {
  var css = `.dSGoY{align-items:center;color:#fff;display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%}[dir] .dSGoY{background:rgba(0,0,0,.5);text-align:center}.ah7Uh{height:20px;width:20px}[dir] .kF1vf{margin-bottom:56px}.cLEV3{font-size:16px;line-height:24px;position:absolute}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var media_item_error_msg_default = {
  "error": "dSGoY",
  "errorIcon": "ah7Uh",
  "errorIconWithMessage": "kF1vf",
  "errorMsg": "cLEV3"
};
export {
  media_item_error_msg_default as default,
  injectCss
};
//# sourceMappingURL=media-item-error-msg-scss.js.map
